import Row from "react-bootstrap/Row";
import React, { useContext } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { OrderContext } from '../../context/orders';
import { Header, NavLinks } from "../common"

const authUser = () => {
  const user = localStorage.getItem("isLoggedIn");
  return user;
};

function ClickAndCollectOrderDetailContent() {
  let isAuthUser = authUser();
  const [orderDetails, setOrderDetails] = React.useState([]);
  const navigate = useNavigate();
  let { orderId } = useParams();
  let { gIdOrder } = useParams();
  const {storeId, setStoreId} = useContext(OrderContext);
  const [isCheckedPickupTag, setIsCheckedPickupTag] =React.useState({});
  React.useEffect(() => {
    if (!storeId) {
      const storedStoreId = localStorage.getItem("storeid");
      if (storedStoreId) {
        setStoreId(storedStoreId);
      }
    }
  }, [storeId, setStoreId]);
  const notifyscucess = (errorMessage) => toast.success(errorMessage);
  const notifyerror = (successMessage) => toast.error(successMessage);

  const fetchorderData = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_STORE_URL}/ccOrders/cc-order-detail/${orderId}`,
      {
        headers: {
          'store-id': storeId,
        },
      }
    );
    if (response.data.orders) {
      setOrderDetails(response.data.orders);
    }
    console.log(response.data.orders)

  };



  React.useEffect(() => {
    if (isAuthUser) {
      navigate(`/cc-order-detail/${orderId}`);
    } else {
      navigate("/login");
    }
    fetchorderData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthUser, orderId]);

  const handleOnChange = (event, fulfillmentLineItemId) => {
    setIsCheckedPickupTag((prevPickupTag) => ({
      ...prevPickupTag,
      [fulfillmentLineItemId]: event.target.checked,
    }));
  };
  //console.log(isCheckedPickupTag);

  // Acts only on the single product row that was clicked (its own fulfillment
  // order line item), instead of the whole order, so each pair can be
  // marked "prête" / "récupérée" independently.
  const handlePickUpStatus = async (e, order, product, status) => {
    e.preventDefault(); // Prevent unwanted reload or propagation

    const statusLabel =
    status === "IN_PROGRESS"
    ? "étant prête à être enlevée"
    : status === "CLOSED"
    ? "Marquée comme enlèvement"
    : status === "OPEN"
    ? "Fulfilled"
    : "";


    const confirmed = window.confirm(`Êtes-vous sûr de vouloir marquer "${product.productName}" comme "${statusLabel}"?`);

    if (!confirmed) {
      return; // Exit if user cancels
    }

    try {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_STORE_URL}/ccOrders/cc-order-detail/pickup`,
        data: {
          orderId: order.id_order,
          warehouseId: storeId,
          pickupStatus: status,
          fulfillmentOrderId: product.fulfillmentOrderId,
          fulfillmentOrderLineItemId: product.fulfillmentOrderLineItemId,
          quantity: product.remainingQuantity || product.productQty,
          order_Id: order.gid_order,
        },
      });

      console.log("Pickup status updated:", response.data);
      notifyscucess(`"${product.productName}" ${statusLabel}`);
      // Shopify sometimes refuses to isolate a single product (fulfillment
      // order already committed as one pickup batch, e.g. from before
      // per-product handling existed). When that happens the backend falls
      // back to validating every remaining product of the batch together.
      if (response.data.batchProcessed) {
        notifyscucess("Les autres produits de ce lot ont aussi été mis à jour : Shopify ne permet plus de les traiter séparément pour cette commande.");
      }
      // The underlying fulfillment order may have been split by the backend,
      // so ids/statuses can only be trusted after refetching from Shopify.
      await fetchorderData();
    } catch (error) {
      if (error.response?.status === 409) {
        alert(error.response.data?.message || 'Status already set.');
      } else {
        console.error("Failed to update pickup status:", error);
        notifyerror(error.response?.data?.message || "Échec de la mise à jour du statut");
      }
    }
  };

  console.log(orderDetails);

  return (
    <>
    <Row className="order-detail-content ">
              <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="dark"
              />
              {orderDetails.map((order) => (
                <>
                  <div className="table-responsive p-0">
                    <table className="ordered-by ">
                      <tbody className="">
                        <tr key={order.id_order}>
                          <td className="text-center p-3">
                            <label> ID commande :</label> {order.id_order}
                          </td>
                          <td className="text-center p-3">
                            <label> Nom et prénom : </label> {order.customername}
                          </td>
                          <td className=" text-center p-3">
                            <label> Référence : </label> {order.reference}
                          </td>
                          <td className="text-center p-3">
                            <label> Type de paiement : </label> {order.payment}
                          </td>
                          <td className="text-center  p-3">
                            <label> Date :</label> {order.added_date}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="table-responsive p-0">
                    <table className="">
                      <thead>
                        <tr className="align-items-center">
                            <th className="p-2"></th>
                            <th className="p-2">ID Produit</th>
                            <th className="p-2 min-width-25">Nom du Produit</th>
                            <th className="p-2 min-width-25">Sku</th>
                            <th className="p-2">Quantité</th>
                            <th className="p-2">Total</th>
                            {/* <th className="p-2">Erreur de préparation</th> */}
                            <th className="p-2 text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody className="">
                        {order.orderProducts.map((product, index) => (
                          <tr
                            key={index}
                            className="align-items-center"
                          >
                            <td className="p-2 justify-content-around d-flex align-items-center ">
                              {/* <input
                                type="checkbox"
                                name="fulfillmentlineitem"
                                className="order-checkbox"
                                value={product.productId}
                              /> */}
                              <img
                                className="img-fluid p-0 m-10"
                                src={product.productImg}
                                alt="productImage"
                                width="100%"
                                height="auto"
                                style={{ maxWidth: "60px" }}
                              />
                            </td>
                            <td className="p-2">{product.productId}</td>
                            <td className="carrier min-width-25 p-2">
                              {product.productName}
                            </td>
                            <td className="carrier min-width-25 p-2">
                              {product.productSku}
                            </td>
                            <td className="p-2">
                              <input
                                type="hidden"
                                name="productqty"
                                value={product.productQty}
                              />
                              {product.productQty}
                            </td>
                            <td className="p-2">{product.productPrice} €</td>
                            {/* <td className="p-2">
                              <input
                              type="checkbox"
                              name="pickuptag"
                              checked={isCheckedPickupTag[order.orderPickUpStatus?.[0]?.fulfillmentId] || false} // Fix: Ensure false when undefined
                              onChange={(e) => handleOnChange(e, order.orderPickUpStatus?.[0]?.fulfillmentId)}
                              />
                            </td> */}
                            <td className="date p-2 text-center ">
                            {/*
                              IN_PROGRESS == Ready for recovery
                              CLOSED == Recovered
                              OPEN == Not processed

                              Each row acts on its own product only (its own
                              fulfillment order line item), so the 2 pairs of
                              an order can be validated independently.
                            */}


                            {product.fulfillmentStatus === "OPEN" && (
                                <span className="btn rounded-pill w-auto px-3 background-none border-blue mt-2"
                                onClick={(e) => handlePickUpStatus(e, order, product, "IN_PROGRESS")}>
                                  Prête à être récupérée
                                </span>
                              )}

                              {product.fulfillmentStatus === "IN_PROGRESS" && (
                                <span className="btn rounded-pill w-auto px-3 background-none border-blue mx-1 mt-2"
                                onClick={(e) => handlePickUpStatus(e, order, product, "CLOSED")}>
                                  Récupérée
                                </span>
                              )}

                              {product.fulfillmentStatus === "CLOSED" && (
                                <p className="mb-0">
                                  Marquée comme enlèvement
                                </p>
                              )}


                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              ))}
              <button
                type="button"
                className="btn btn-primary m-4 rounded-pill w-auto p-20 border-coupon blue-background"
                onClick={() => window.history.back()}
              >
                Retour
              </button>
            </Row>
    </>
  );
}

export default ClickAndCollectOrderDetailContent;
